import { render, staticRenderFns } from "./TestingContent.vue?vue&type=template&id=0cd5b5c1&lang=pug"
import script from "./TestingContent.vue?vue&type=script&lang=js"
export * from "./TestingContent.vue?vue&type=script&lang=js"
import style0 from "./TestingContent.vue?vue&type=style&index=0&id=0cd5b5c1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports